import Aegis from '@tencent/aegis-web-sdk';

const aegis = new Aegis({
  id: process.env.VUE_APP_AEGIS_ID, // 项目ID
  reportApiSpeed: true, // 开启接口测速
  reportAssetSpeed: true, // 开启静态资源测速
  spa: true,
  api: {
    apiDetail: true,
    retCodeHandler(res) {
      try {
        const { ret } = JSON.parse(res);
        return {
          isErr: ![0, 300011].includes(ret), // 0正常,300011拉不到角色也属于正常
          ret,
        };
      } catch (e) { }
      return {
        isErr: true,
        ret: 99999, // TODO 上报无返回结果的请求
      };
    },
  },
});

export default aegis;
